module.exports = __webpack_public_path__ + "static/media/planeta3.934adace.png";